<template>
  <div>
    <div class="order_detial">注文の詳細</div>
    <div class="order_Pdetial">
      <span @click="back"><img src="../../assets/images/users/Return.png"></span>
      <span>注文の詳細</span>
      <span></span>
    </div>
    <div class="order_detial_main">
      <ul class="detial_main_navtop">
        <li>商品画像</li>
        <li>商品名</li>
        <li>商品数量</li>
        <li>商品単価</li>
      </ul>
      <div class="detial_main_main">
        <ul class="payment_main_goods">
          <li><span><img src="../../assets/images/goods/cart_goods_img.png"></span></li>
          <li><p><span>持续吸收性VB</span></p></li>
          <li><p><span>￥960</span></p></li>
          <li><p><span>X2</span></p></li>
        </ul>
        <div class="payment_main_footer">
          <span>小計：<label>￥132</label></span>
          <span>合計<label>1</label>点</span>
        </div>
      </div>
      <div class="detial_main_Pmain">
        <ul class="payment_main_goods">
          <li><img src="../../assets/images/goods/cart_goods_img.png"></li>
          <li><p><span>持续吸收性VB</span></p></li>
          <li><p><span>￥960</span></p></li>
          <li><p><span>X2</span></p></li>
        </ul>
        <div class="payment_main_footer">
          <span>小計：<label>￥132</label></span>
          <span>合計<label>1</label>点</span>
        </div>
      </div>
      <ul class="detial_footer">
        <li><span>注文時間:2018-12-23</span></li>
        <li><span>注文番号:8888888888888</span></li>
        <li><span>発注時間:2018-12-23 18:23</span></li>
        <li><span>物流会社:顺丰快递</span></li>
        <li><span>送り状番号:8888888888888</span></li>
        <li></li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
      }
    },
    created(){
    },
    methods: {
      back(){
        this.$router.go(-1)
      }
    },
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc.scss";
  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .order_detial {
     display: none;
    }
    .order_Pdetial{
      height: 50px;
      background-color: $TitColor;
      display: flex;
      justify-content: space-between;
      line-height: 50px;
      color: $whiteColor;
      position: fixed;
      top:0;
      left:0;
      right:0;
      span:nth-child(1),
      span:nth-child(3) {
        width: 50px;
        display: inline-block;
        height: 50px;
        img {
          margin-top: 10px;
          margin-left: 10px;
        }
      }
    }
    .order_detial_main {
      margin-top: 50px;
      width: 100%;
      font-size: 14/$default-w+rem;
      .detial_main_navtop {
        height: 20px;
        padding: 10px 0;
        background-color: #f6f7f9;
        line-height: 20px;
        li {
          float: left;
          width: 25%;
          text-align: center;
        }
      }
      .detial_main_main {
       display: none;
      }
      .detial_main_Pmain{
        background-color: white;
        margin-top: 5px;
        .payment_main_goods {
          width: 100%;
          height: 100px;
          li {
            float: left;
            width: 25%;
            height: 100px;
            text-align: center;
            img {
              width: 90%;
              height: 92%;
              padding: 4% 5%;
            }
            p {
              height: 50px;
              margin-top: 25px;
              display: flex;
              align-items: center;
              span {
                text-align: center;
                width: 100%;
              }
            }
          }
        }
        .payment_main_footer {
          height: 30px;
          width: 100%;
          background-color: white;
          border-top: 1px solid #ddd;

          span {
            line-height: 30px;
            float: right;
            margin-right: 20px;
            label {
              color: #e0a191;
            }
          }
        }
      }
      .detial_footer {
        width: 100%;
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-around;
        align-content: space-around;
        background-color: white;

        li{
          border-bottom: 1px solid #f0f0f0;
          width: 49%;
          height: 30px;
          line-height: 30px;
          padding: 5px 0;
        }
        li:nth-child(6){
          border-bottom: none;
        }
      }
    }

  }
  @media screen and(min-width: $P750screen){
    .order_detial {
      height: 50px;
      width: 100%;
      background-color: #dcdcdc;
      text-align: center;
      line-height: 50px;
    }
    .order_Pdetial{
     display: none;
    }
    .order_detial_main {
      width: 100%;
      font-size: 14px;
      .detial_main_navtop {
        height: 20px;
        padding: 10px 0;
        background-color: #f6f7f9;
        line-height: 20px;
        li {
          float: left;
          width: 25%;
          text-align: center;
        }
      }
      .detial_main_main {
        background-color: white;
        margin-top: 5px;
        .payment_main_goods {
          width: 100%;
          height: 110px;
          li {
            float: left;
            width: 25%;
            height: 110px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            img {
              margin-top: 10px;
            }
            p{
              width: 100%;
              height: 50px;
              margin: 25px 0;
              display: flex;
              align-items: center;
              span{
                width: 100%;
                text-align: center;
              }
            }
          }
        }
        .payment_main_footer {
          width: 100%;
          height: 20px;
          background-color: #f6f7f9;
          padding: 10px 0;
          span {
            float: right;
            font-size: 14px;
            margin-right: 20px;
            line-height: 20px;
            label {
              font-size: 20px;
              color: #e0a191;
            }
          }
        }
      }
      .detial_main_Pmain{
        display: none;
      }
      .detial_footer {
        width: 75%;
        margin: 0 auto;
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-around;
        align-content: space-around;
        background-color: white;

        li{
          border-bottom: 1px solid #f0f0f0;
          width: 49%;
          height: 30px;
          line-height: 30px;
          padding: 5px 0;
        }
        li:nth-child(6){
          border-bottom: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/order_detial.vue